import React, { useState } from "react";
import { Drawer } from "@mui/material";
import styled from "styled-components";
import { CloseIcon } from "../../shared/icons";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import TextInputField from "../../components/formik/TextInputField";
import SelectDropdownField from "../../components/formik/SelectDropdownField";
import { AppDispatch, RootState } from "../../store";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import {
  clearFilters,
  setFilters,
} from "../../slices/Filter/CollectionNFTFilterSlice";

const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid rgba(204, 204, 204, 1);
  padding: 24px 20px;

  h5 {
    margin: 0;
    font-family: "Manrope", sans-serif;
    font-size: 20px;
    font-weight: 700;
    color: rgba(9, 28, 0, 1);
  }

  .close-icon {
    cursor: pointer;
  }
`;

// form
const FormContainer = styled.div`
  padding: 24px 20px;
`;

const FieldWrapper = styled.div`
  margin-bottom: 20px;
`;

const ActionsWrapper = styled.div`
  border-top: 1px solid rgba(204, 204, 204, 1);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px 20px;
`;

const ClearButton = styled.button`
  cursor: pointer;
  outline: none;
  padding: 12px 20px;
  border: 2px solid #ff9d59;
  border-radius: 80px;
  color: #ff9d59;
  background: transparent;
  font-family: "Manrope", sans-serif;
  font-size: 16px;
  font-weight: 600;
`;

const ApplyButton = styled.button`
  cursor: pointer;
  outline: none;
  padding: 12px 20px;
  border: 2px solid #ff9d59;
  border-radius: 80px;
  color: #fff;
  background: #ff9d59;
  font-family: "Manrope", sans-serif;
  font-size: 16px;
  font-weight: 600;
`;

interface Props {
  isOpen: boolean;
  onClose: () => void;
  getFilteredNFTs: (
    name: string,
    rank_by: string,
    limit?: number,
    pageNo?: number,
    isLoadingMore?: boolean
  ) => void;
}

const FilterDrawer: React.FC<Props> = ({
  isOpen,
  onClose,
  getFilteredNFTs,
}) => {
  const dispatch: AppDispatch = useDispatch();
  const filters = useSelector((state: RootState) => state.CollectionNFTFilter);
  const [initialValues, setInitialValues] = useState({});

  const validationSchema = Yup.object({
    // name: Yup.string().required("Name is required"),
  });

  const handleSubmit = (values: any) => {
    dispatch(setFilters(values));
    getFilteredNFTs(values?.name, values?.impactScore);
    onClose();
  };

  const handleClearAll = (resetForm: () => void) => {
    resetForm();
    dispatch(clearFilters());
    getFilteredNFTs("", "");
    onClose();
  };

  return (
    <Drawer
      anchor="right"
      open={isOpen}
      onClose={onClose}
      sx={{
        "& .MuiPaper-root.MuiDrawer-paper": {
          width: "340px",
        }
      }}
    >
      {/* header */}
      <HeaderContainer>
        <h5>Filter</h5>
        <CloseIcon className="close-icon" onClick={onClose} />
      </HeaderContainer>
      {/* filter form */}

      <Formik
        initialValues={filters}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(props) => (
          <Form>
            <FormContainer>
              <FieldWrapper>
                <TextInputField
                  label="Filter by Name"
                  name="name"
                  type="text"
                  placeholder="Enter name"
                />
              </FieldWrapper>
              {/* <FieldWrapper>
                <SelectDropdownField
                  label="Categories"
                  name="categories"
                  options={[{ value: "option1", label: "Option 1" }]}
                  placeholder="Select categories"
                />
              </FieldWrapper>
              <FieldWrapper>
                <SelectDropdownField
                  label="Blockchain Network"
                  name="network"
                  options={[{ value: "option1", label: "Option 1" }]}
                  placeholder="Select network"
                />
              </FieldWrapper>
              <FieldWrapper>
                <SelectDropdownField
                  label="Filter by Badge"
                  name="badge"
                  options={[{ value: "option1", label: "Option 1" }]}
                  placeholder="Select badge"
                />
              </FieldWrapper>
              <FieldWrapper>
                <SelectDropdownField
                  label="Eco Categories"
                  name="ecoCategories"
                  options={[{ value: "option1", label: "Option 1" }]}
                  placeholder="Select category"
                />
              </FieldWrapper> */}
              <FieldWrapper>
                <SelectDropdownField
                  label="Rank by Impact Score"
                  name="impactScore"
                  options={[
                    { value: "highToLow", label: "High To Low" },
                    { value: "lowToHigh", label: "Low To High" },
                  ]}
                  placeholder="Select score"
                />
              </FieldWrapper>
            </FormContainer>
            <ActionsWrapper>
              <ClearButton
                type="button"
                onClick={() => handleClearAll(props?.resetForm)}
              >
                Clear All
              </ClearButton>
              <ApplyButton type="submit">Apply</ApplyButton>
            </ActionsWrapper>
          </Form>
        )}
      </Formik>
    </Drawer>
  );
};

export default FilterDrawer;
